// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__as1Wy","inputWrap":"CustomTip_inputWrap__12Pgg"};